import { updateAllQueries } from 'api/urql/helpers/mutation';
import { query } from 'components/pages/import/queries/getImportedDrafts';

export const postJobRequest = (results, args, cache, info) => {
  // handlers go here
  updateAllQueries({
    fieldName: 'importedDrafts',
    query,
  })(results, args, cache, info);
};
